// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { TriggerValueOverride, ITriggerValueOverride } from "./Shared.Models.Api.V1.DeviceCommands.TriggerValueOverride.gen";

export interface IDriverOverrideCommandParams {
	triggerEnabled: { [key: string]: boolean } | undefined;

	triggerValues: { [key: string]: ITriggerValueOverride } | undefined;

	leftPassLanes: number | undefined;

	rightPassLanes: number | undefined;

	sidePassMinSpeed: number | undefined;

	snoozeRelay: number | undefined;

	snoozeSeconds: number | undefined;

	snoozeUntilUtc: string | undefined;

	clearAll: boolean;

	$type?: string | undefined;
}
export class DriverOverrideCommandParams {
	constructor(data?: IDriverOverrideCommandParams) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.snoozeUntilUtc) { this.snoozeUntilUtc = new Date(data.snoozeUntilUtc); }
	}

	triggerEnabled: { [key: string]: boolean } | undefined;

	triggerValues: { [key: string]: TriggerValueOverride } | undefined;

	leftPassLanes: number | undefined;

	rightPassLanes: number | undefined;

	sidePassMinSpeed: number | undefined;

	snoozeRelay: number | undefined;

	snoozeSeconds: number | undefined;

	snoozeUntilUtc: Date | undefined;

	clearAll: boolean = false;

	static $type: string = "CoreApi.Models.DeviceCommands.DriverOverrideCommandParams, ";
	$type?: string | undefined = DriverOverrideCommandParams.$type;
}

